import { render, staticRenderFns } from "./memberConsumeRecord.vue?vue&type=template&id=0a8eafd0&scoped=true"
import script from "./memberConsumeRecord.vue?vue&type=script&lang=ts"
export * from "./memberConsumeRecord.vue?vue&type=script&lang=ts"
import style0 from "./memberConsumeRecord.vue?vue&type=style&index=0&id=0a8eafd0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8eafd0",
  null
  
)

export default component.exports